import axios from "axios";
import RestService from "../../../helpers/RestService";

axios.defaults.headers.common = {
  'Accept': 'application/json, text/plain',
  'X-CSRF-Token': RestService.getCsrfToken(),
  'X-Requested-With' : 'XMLHttpRequest',
};

axios.defaults.headers.post['Content-Type'] = 'application/json';


export async function getQuiz() {
  try {
    const {data} = await axios.get('/api/quizs/get-by-owner');

    if(data.errcode == 200){
      return data.payload;
    } else {
      return Promise.reject({message: 'Bad request'});
    }
  } catch (error) {
    return Promise.reject({message: 'Bad request'});
  }
}


export async function createQuiz(body, questions) {
  try {
    const {data} = await axios.post('/api/quiz/post', body);

    if(data.errcode == 200){
      return data.payload;
    } else {
      return Promise.reject({message: 'Bad request'});
    }
  } catch (error) {
    return Promise.reject({message: 'Bad request'});
  }
}

export async function addQuestionQiuz(quiz_id, questions) {
  try {
    const {data} = await axios.post('/api/quiz/questions-add', {
      quiz_id,
      questions,
    })

    if(data.errcode == 200){
      return data.payload;
    } else {
      return Promise.reject({message: 'Bad request'});
    }

  } catch (error) {
    return Promise.reject({message: 'Bad request'});
  }
}


// WEBPACK FOOTER //
// ./yii2/frontend/frontend-assets/src/components/QbmPage/QbmQuiz/actions.js